import { Input, Modal, Button, message, Empty, Image } from 'antd'
import React, { useEffect, useState, useRef } from 'react'
import { useTranslation } from 'react-i18next'
import { http } from '@services/http'
import SuccessModal from '@Modal/SuccessModal'
import ErrorModal from '@Modal/ErrorModal'
import { useQuery } from '@tanstack/react-query'
import moment from 'moment'
import { config } from '../../../config'

const ImageTab = ({ data }) => {
	const { t } = useTranslation()

	const [selectedImage, setSelectedImage] = useState(null)
	const [path, setPath] = useState([])
	const [imageKeys, setImageKeys] = useState('')

	const fetchImagesWithKeys = async ({ queryKey }) => {
		const [_, keys] = queryKey
		if (keys) {
			try {
				let url = `api/assets/multiple/${keys}`
				const { data } = await http.get(url)
				console.log(data)
				return data
			} catch (error) {
				console.log(error)
			}
		}
	}

	const { data: images = [], isLoading } = useQuery({
		queryKey: ['images', imageKeys],
		queryFn: fetchImagesWithKeys,
		keepPreviousData: false,
		refetchOnWindowFocus: true,
	})

	useEffect(() => {
		if (data?.u_ChertejId) {
			const photoId = data?.u_ChertejId

			setImageKeys(photoId)
		}
	}, [data])

	const downloadImage = async (path) => {
		try {
			const res = await http.get(`api/assets/download/${path}`, {
				responseType: 'blob',
			})

			const url = window.URL.createObjectURL(
				new Blob([res.data], { type: 'image/png' }),
			)

			const link = document.createElement('a')
			link.href = url
			link.setAttribute('download', 'BP.png')
			document.body.appendChild(link)
			link.click()
			document.body.removeChild(link)
			window.URL.revokeObjectURL(url)
		} catch (error) {
			message.error(t('errorDownload'))
		}
	}
	const viewImage = (path) => {
		http.get(`api/assets/${path}`)
		setSelectedImage(`${config.baseURL}api/assets/download/${path}`)
	}

	return (
		<div className="flex w-full items-end gap-5 mt-5">
			{images.length > 0 && images ? (
				<Image.PreviewGroup
					preview={{
						onChange: (current, prev) =>
							console.log(
								`current index: ${current}, prev index: ${prev}`,
							),
					}}
				>
					{images?.map((image, index) =>
						image.path ? (
							<div
								key={image.key}
								className="flex w-full items-start flex-col gap-3 "
							>
								<div>
									<p className="font-bold">
										{t('drawingPhoto')}-{index + 1}
									</p>
								</div>
								<div className="flex flex-col items-center gap-3">
									<Image
										width={200}
										src={`${config.baseURL}${image.path}`}
										placeholder={
											<Image
												preview={false}
												src={`${config.baseURL}${image.path}`}
												width={200}
											/>
										}
									/>
									<Button
										onClick={() => downloadImage(image.key)}
										className="h-12 w-[100px] rounded-3xl bg-[#0A4D68] text-white"
									>
										{t('download')}{' '}
									</Button>
								</div>
							</div>
						) : (
							''
						),
					)}
				</Image.PreviewGroup>
			) : (
				<div className="w-full mt-10 mb-10 flex items-center justify-center">
					<Empty image={Empty.PRESENTED_IMAGE_SIMPLE} />
				</div>
			)}

			<Modal
				open={!!selectedImage}
				onCancel={() => setSelectedImage(null)}
				footer={null}
				centered
				// width="80%"
				// zIndex={1050}
			>
				<img
					src={selectedImage}
					alt="Large preview"
					className="max-w-full max-h-[80vh] mx-auto"
				/>
			</Modal>
		</div>
	)
}

export default ImageTab
